import { AssociateAction, AssociationState } from '@/types/pages/storeManagement/device/associate';
import { createContext, useContext } from 'react';

type AssociationContextType = {
    state: AssociationState;
    dispatch: React.Dispatch<AssociateAction>;
};

export const AssociationContext = createContext<AssociationContextType | null>(null);

export const useAssociationState = () => {
    const context = useContext(AssociationContext);
    if (!context) {
        throw new Error('useAssociateState must be used within a AssociationProvider');
    }
    return context;
};
